(function () {
    var url = document.referrer;
    var seoName = '';
    function checkSeo() {
        // 如果链接是站内则停止检查
        if (url.indexOf('dellemc-solution.com') > -1 || !url) {
            // console.log('如果链接是站内则停止检查seo');
            return false;
        }

        // 如果链接带urm参数则停止检查
        if (window.location.search.indexOf('utm_') > -1) {
            common.delCookie('seoName');
            return false;
        }

        var seoList = ['baidu.com', 'so.com', 'bing.com', 'google.com', 'sogo.com'];
        seoList.forEach((item) => {
            if (url.indexOf(item) > -1) {
                seoName = item;
                common.setCookie('seoName', item);
                common.delCookie('utmUrl');
                console.log('来自SEO', seoName, url);
            }
        });

        if (seoName) {
            return seoName;
        } else {
            common.delCookie('seoName');
            return false;
        }
    }

    checkSeo();
})();